<template>
  <div id="loading-bg">
    <div class="loading-logo">
      <img src="@/assets/images/logo/logo.png" alt="Logo">
    </div>
    <div class="loading">
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleLoginEvent (data) {
      //console.log('HANDLELOGINEVENT')
      //console.log(data)
      this.$store.dispatch('updateUserInfo', {
        displayName: this.$store.state.AppActiveUser.displayName,
        email: this.$store.state.AppActiveUser.email,
        photoURL: this.$store.state.AppActiveUser.photoURL,
        providerId: 'jwt',
        uid: this.$store.state.AppActiveUser.uid,
        tenantsId: this.$store.state.AppActiveUser.tenantsId,
      })
      this.$router.push(data.state.target || '/')
    }
  },
  created () {
    this.$auth.handleAuthentication()
    if (this.$auth.isAuthenticated()) this.$router.push('/').catch(() => {})
  }
}

</script>

<style lang="scss">
@import "../assets/css/loader.css";
</style>
